(function () {
  function extractGA4ClientId() {
    var cookieString = document.cookie;
    var gaMatch = cookieString.match(/_ga=GA1\.[0-9]\.([0-9]+\.[0-9]+)/);
    return gaMatch && gaMatch[1] ? gaMatch[1] : "";
  }

  function syncClientId() {
    var clientId = extractGA4ClientId();
    if (!clientId) {
      return false; // gtag.jsがまだ_gaを発行していない
    }

    var lastSynced = window.sessionStorage.getItem("ga4_client_id_last_synced");
    if (lastSynced === clientId) {
      return true;
    }

    // (1) ストアフロント系イベント向け: カスタムイベントとしてピクセルへ publish
    if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
      window.Shopify.analytics.publish("my_store:ga4_ids_sync", {
        ga_client_id: clientId
      });
    }

    // (2) チェックアウト系イベント向け: カート属性として保存
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        attributes: { ga_client_id: clientId }
      }),
      keepalive: true
    }).then(function () {
      window.sessionStorage.setItem("ga4_client_id_last_synced", clientId);
    }).catch(function (err) {
      console.warn("GA4 client_id sync to cart attributes failed:", err);
    });

    return true;
  }

  // ページ読み込み時に試行。GA4のCookie発行が間に合っていない場合に備えて
  // 数回リトライする。
  var attempts = 0;
  var maxAttempts = 10;
  var intervalId = setInterval(function () {
    attempts++;
    var success = syncClientId();
    if (success || attempts >= maxAttempts) {
      clearInterval(intervalId);
    }
  }, 500);
})();
